import axios from "@/plugins/axios";

export default {
  getDocument(id) {
    return axios.get(`/supplier_documents/${id}`);
  },
  getDocumentList(supplier_id) {
    return axios.get(`/suppliers/${supplier_id}/documents`);
  },

  addDocument(supplier_id, { name, key }) {
    return axios.post(`/suppliers/${supplier_id}/documents`, { name, key });
  },
  updateDocument(id, { display_name, old_name, dependent_id }) {
    // Note: CANNOT replace actual document
    // Other specifics (eg. Name) only
    return axios.post(`/supplier_documents/${id}`, {
      display_name,
      old_name,
      supplier_id: dependent_id,
    });
  },
  deleteDocument(id) {
    return axios.delete(`/supplier_documents/${id}`);
  },
  deleteDocumentList(idList) {
    return axios.delete("/supplier_documents", {
      data: { document_list: idList },
    });
  },
  updateDocumentOrder(supplier_id, updatedDocumentList) {
    return axios.post(`/suppliers/${supplier_id}/documents_order`, { data: updatedDocumentList });
  },
};
